var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.624 2.037a9.078 9.078 0 0 1-2.427.638A4.05 4.05 0 0 0 20.05.443a8.64 8.64 0 0 1-2.67.977A4.307 4.307 0 0 0 14.302.143c-2.331 0-4.208 1.814-4.208 4.038 0 .32.028.628.097.92-3.5-.163-6.599-1.772-8.68-4.222a3.937 3.937 0 0 0-.576 2.04c0 1.399.75 2.638 1.87 3.356a4.297 4.297 0 0 1-1.902-.498v.045c0 1.961 1.46 3.591 3.374 3.966-.343.09-.717.133-1.105.133a3.88 3.88 0 0 1-.797-.069c.546 1.6 2.094 2.775 3.935 2.813a8.696 8.696 0 0 1-5.221 1.722c-.346 0-.677-.015-1.008-.056 1.865 1.153 4.076 1.812 6.46 1.812 7.75 0 11.986-6.154 11.986-11.488 0-.179-.006-.35-.015-.522a8.218 8.218 0 0 0 2.11-2.096z"}));
}

Twitter.defaultProps = {"viewBox":"0 0 21 17"};

module.exports = Twitter;

Twitter.default = Twitter;
